import useSWR from "swr";
import { customFetcher, getTsDate, notify } from "../../../utils";
import { CronJob, CronJobEmail } from "../../../globals/interfaces";
import { useState } from "react";
import apiClient from "../../../apiClient";
import useUser from "../../../customHooks/useUser";

const JOB_ROUTE = '/automated-email-alerts/job';
const JOB_EMAILS_ROUTE = '/automated-email-alerts/job/email';

export default function useData () {

    const { user } = useUser();
    const [cronJobId, setCronJobId] = useState<number>();

    const {
        data: jobs,
        mutate: refreshJobs
    } = useSWR(JOB_ROUTE, customFetcher<CronJob>, {
        fallbackData: []
    });

    const {
        data: emails,
        mutate: refreshEmails
    } = useSWR(cronJobId ? `${JOB_EMAILS_ROUTE}/${cronJobId}` : null, customFetcher<CronJobEmail>);
    
    const selectedJob = jobs.find(item => item.cronJobId == cronJobId);

    const updateCronJob = async (displayName: string, description: string) => {
        const data: Partial<CronJob> = {
            displayName,
            description
        }
        await apiClient.put(`${JOB_ROUTE}/${selectedJob.cronJobId}`, data);
        refreshJobs();
    }

    const addEmail = async (email: string) => {
        const data: Partial<CronJobEmail> = {
            email,
            cronJobId: selectedJob.cronJobId,
            createdBy: user.s_email,
            createdDate: getTsDate()
        }
        await apiClient.post(JOB_EMAILS_ROUTE, data);
        refreshEmails();
    }

    const deleteEmail = async (cronJobEmail: CronJobEmail) => {
        if (!cronJobEmail) {
            alert('no cronJobEmail to delete');
            return;
        }
        await apiClient.delete(`${JOB_EMAILS_ROUTE}/${cronJobEmail.cronJobEmailId}`);
        refreshEmails();
    }

    return {
        jobs, 
        refreshJobs,
        emails,
        refreshEmails,
        cronJobId, 
        setCronJobId,
        selectedJob,
        updateCronJob,
        addEmail,
        deleteEmail
    };
}